import { Check, Copy } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import { Tag } from "common/components/ui/Tag";
import useCopyText from "common/hooks/useCopyText";

export default function CopiableTag({ value }: { value: string }) {
  const { isCopied, copyText } = useCopyText(value);

  return (
    <div className="flex items-center gap-x-1">
      <Tag variant="tertiary">
        {`${value.slice(0, 13)}...${value.slice(-2)}`}
      </Tag>
      <Button
        size="xs"
        intent="iconOnly"
        variant="outline-purple"
        onClick={copyText}
      >
        {isCopied ? <Check /> : <Copy />}
      </Button>
    </div>
  );
}
